<template>
  <div>
    <v-card flat class="mt-7">
      <v-card-text>
        <v-tabs class="tabs-pill" v-model="tab">
          <v-tab>{{ $t("animal.all") + "(" + all + ")" }}</v-tab>
          <v-tab>{{ $t("animal.groupedAnimals") + "(" + grouped + ")" }}</v-tab>
          <v-tab>{{
            $t("animal.ungroupedAnimals") + "(" + ungrouped + ")"
          }}</v-tab>
        </v-tabs>
      </v-card-text>
    </v-card>
    <v-card class="pa-4">
      <v-data-table
        v-model="selected"
        :single-select="false"
        selectable-key="id"
        :show-select="tab == 2"
        item-key="id"
        :headers="headers"
        :items="items"
        :items-per-page="10"
        :loading="loading"
        loading-text="Loading... Please wait"
        :options.sync="tableOptions"
        :server-items-length="totalRecords"
        :footer-props="{
          'items-per-page-options': itemsPerPageOptions,
          showFirstLastPage: true,
          'items-per-page-text': $t('geneticsAndBreeding.rowsPerPage'),
        }"
        @pagination="paginationChanged"
        :header-props="{
          'sort-icon': 'mdi-unfold-more-horizontal',
        }"
      >
        <template v-slot:top>
          <div class="d-flex mt-5">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              outlined
              :placeholder="$t('geneticsAndBreeding.searchByAnimalIdName')"
              dense
              style="max-width: 25%"
              v-model="search"
              @input="searchEPD"
            ></v-text-field>
            <!-- <v-btn
                :disabled="search.length < 1"
                color="primary"
                height="40"
                width="40"
                max-width="40"
                outlined
                class="ml-8"
                @click="searchEPD"
              >
                <v-icon>mdi-filter-outline</v-icon>
              </v-btn> -->
            <v-spacer></v-spacer>
            <v-btn
              v-if="tab == 2 && selected.length > 0"
              class="mr-4 font-weight-bold"
              depressed
              @click="deleteEpdPage"
              >BULK DELETE</v-btn
            >

            <div class="pt-2 pr-2 black--text">
              {{ $t("geneticsAndBreeding.rowsPerPage") }}
            </div>
            <v-select
              style="max-width: 63px"
              v-model="tableOptions.itemsPerPage"
              dense
              :items="itemsPerPageOptions"
              class="mr-5"
            ></v-select>
            <div class="py-1 title">
              {{ from }} - {{ to }} of {{ totalRecords }}
            </div>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="tableOptions.page <= 1"
              @click="pageChange(false)"
            >
              <v-icon dark> mdi-chevron-left </v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="tableOptions.page >= totalPages"
              @click="pageChange(true)"
            >
              <v-icon dark> mdi-chevron-right </v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              @click="$router.push({ name: 'GeneticsGrid' })"
            >
              <v-icon dark> mdi-view-grid-outline </v-icon>
            </v-btn>
            <!-- <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
              >
                <v-icon dark> mdi-format-list-bulleted </v-icon>
              </v-btn> -->
          </div>
        </template>
        <template v-slot:progress>
          <v-progress-linear
            color="primary"
            :height="8"
            indeterminate
          ></v-progress-linear>
        </template>
        <template v-slot:item.animalNumber="{ item }">
          <span
            ><a
              @click.prevent="
                $router.push({
                  name: 'SingleAnimalEpd',
                  params: { geneticid: item.animalNumber },
                })
              "
              >{{ item.animalNumber }}</a
            ></span
          >
        </template>

        <template v-slot:header.birthWeight="{}">
          <span class=""
            >{{ $t("geneticsAndBreeding.birthWeightEpd") }}({{
              weightUnit
            }})</span
          >
        </template>
        <template v-slot:item.birthWeight="{ item }">
          <span class="text-capitalize">{{
            !item.birthWeight || Number.isInteger(item.birthWeight)
              ? item.birthWeight
              : item.birthWeight.toFixed(2)
          }}</span>
        </template>
        <template v-slot:header.weaningWeight="{}">
          <span class=""
            >{{ $t("geneticsAndBreeding.weaningWeightEpd") }}({{
              weightUnit
            }})</span
          >
        </template>
        <template v-slot:item.weaningWeight="{ item }">
          <span class="text-capitalize">{{
            !item.weaningWeight || Number.isInteger(item.weaningWeight)
              ? item.weaningWeight
              : item.weaningWeight.toFixed(2)
          }}</span>
        </template>
        <template v-slot:header.yearlingWeight="{}">
          <span class=""
            >{{ $t("geneticsAndBreeding.yearlingWeightEpd") }}({{
              weightUnit
            }})</span
          >
        </template>
        <template v-slot:item.yearlingWeight="{ item }">
          <span class="text-capitalize">{{
            !item.yearlingWeight || Number.isInteger(item.yearlingWeight)
              ? item.yearlingWeight
              : item.yearlingWeight.toFixed(2)
          }}</span>
        </template>
        <template v-slot:item.birthDate="{ item }">
          <span class="text-no-wrap">{{ item.birthDate }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon @click="updateEpdPage(item)"
            ><v-icon>mdi-pencil</v-icon></v-btn
          >
          <v-btn icon @click="deleteEpdPage(item)"
            ><v-icon>mdi-delete</v-icon></v-btn
          >
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="alertdialog" width="400" persistent>
      <v-card class="custom-card" rounded="0">
        <v-toolbar flat color="secondary" class="white--text">
          <v-toolbar-title class="font-weight-bold">
            Delete Animals?
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon class="white--text" @click="closeAlert">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="addCalvingRecord"
          >
            <v-row class="mb-3">
              <v-col cols="12">
                <b>
                  Are you sure you want to delete
                  {{ selected.length > 0 ? selected.length : "" }} Animals from
                  the listing?<br />
                  By clicking on yes the animal will be removed permanently from
                  the list
                </b>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-actions class="mt-3">
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                type="submit"
                min-width="113"
                large
                v-on:click="closeAlert()"
              >
                NO
              </v-btn>
              <v-btn
                color="primary"
                type="submit"
                min-width="113"
                large
                v-on:click="confirmDelete()"
              >
                YES
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import gql from "graphql-tag";

export default {
  apollo: {
    epdCounts: {
      query: gql`
        query countEpd($userId: Int!) {
          countEpd(userId: $userId) {
            all
            grouped
            ungroupped
          }
        }
      `,
      variables() {
        return {
          userId: parseInt(this.$store.getters.getUser.userDetail.id),
        };
      },

      result: function ({ data }) {
        if (data) {
          //array1.shift();
          this.all = data.countEpd.all;
          this.grouped = data.countEpd.grouped;
          this.ungrouped = data.countEpd.ungroupped;
        }
      },
      update: data => {
        return data.countEpd;
      },
      error: err =>
        this.$notify({
          title: "Error loading epd count!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },
    epdData: {
      query: gql`
        query searchEdp($searchEdpInput: SearchEdpInput!) {
          searchEdp(searchEdpInput: $searchEdpInput) {
            rows {
              id
              animal_id
              birth_weight_epd
              weaning_weight_epd
              yearling_weight_epd
              birth_weight_kg
              weaning_weight_kg
              yearling_weight_kg
              birthDate
              gender
              name
              animalNumber
              source
            }
            count
            returnedRecords
            weightUnit
          }
        }
      `,
      variables() {
        return {
          searchEdpInput: this.filter,
        };
      },
      result: function ({ data }) {
        if (data) {
          console.log(
            data.searchEdp.rows,
            "data.searchEdp.rowsdata.searchEdp.rows"
          );
          //array1.shift();
          this.items = data.searchEdp.rows;
          this.weightUnitt = data.searchEdp.weightUnit;
          this.totalRecords = data.searchEdp.count;
          this.totalPages = Math.ceil(
            this.totalRecords / this.tableOptions.itemsPerPage
          );
          this.from =
            (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
          this.to =
            this.tableOptions.page * this.tableOptions.itemsPerPage -
            (this.tableOptions.itemsPerPage - data.searchEdp.returnedRecords);

          // this.all = data.countEpd.all;
          // this.grouped = data.countEpd.grouped;
          // this.ungrouped = data.countEpd.ungroupped;
        }
      },
      update: data => {
        return data.searchEdp;
      },
      error: err =>
        this.$notify({
          title: "Error loading animal diseases!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },
  },
  mounted() {
    // if(this.$route.query.page){
    //   this.tableOptions.page = Number(this.$route.query.page)
    // }else{
    //   this.$router.replace(
    //     {query: { page: this.tableOptions.page}}
    //   )
    // }
  },
  watch: {
    tab: {
      handler() {
        this.getEPDData();
      },
      deep: true,
    },
    tableOptions: {
      handler() {
        this.getEPDData();
      },
      deep: true,
    },
    "$route.query": {
      handler(v) {
        if (v?.page) {
          this.tableOptions.page = Number(v.page);
        } else {
          this.$router.replace({ query: { page: this.tableOptions.page } });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    weightUnit() {
      return (this.weightUnitt || "lbs").toLowerCase();
    },
  },
  data() {
    return {
      valid: false,
      alertdialog: false,
      itemsPerPageOptions: [10, 25, 50, 100, 500],
      weightUnitt: "lbs",
      loading: false,
      search: "",
      selected: [],
      filter: {
        page: 1,
        limit: 10,
        searchPhrase: "",
        //userId:6
        userId: parseInt(this.$store.getters.getUser.userDetail.id),
      },
      totalRecords: 1,
      totalPages: 0,
      to: 0,
      from: 0,
      tableOptions: {},
      tab: 0,
      tabs: ["all", "grouped", "ungrouped"],
      grouped: 0,
      ungrouped: 0,
      all: 0,
      items: [],
      headers: [
        {
          text: this.$t("geneticsAndBreeding.animalID"),
          value: "animalNumber",
          class: "text-no-wrap black--text",
          align: "start",
        },
        {
          text: this.$t("geneticsAndBreeding.animalName"),
          value: "name",
          class: "text-no-wrap black--text px-0",
          align: "start",
        },
        {
          text: this.$t("geneticsAndBreeding.tag"),
          value: "tagNumber",
          class: "text-no-wrap black--text",
          align: "start",
        },
        {
          text: this.$t("geneticsAndBreeding.gender"),
          value: "gender",
          class: "text-no-wrap black--text",
          align: "start",
        },
        {
          text: this.$t("geneticsAndBreeding.birthDate"),
          value: "birthDate",
          class: "text-no-wrap black--text",
          align: "start",
        },
        {
          text: this.$t("geneticsAndBreeding.birthWeightLb"),
          value: "birthWeight",
          class: "black--text text-no-wrap px-0",
          align: "start",
        },
        {
          text: this.$t("geneticsAndBreeding.weaningWeightLb"),
          value: "weaningWeight",
          align: "start",
          class: "black--text text-no-wrap px-0",
        },
        {
          text: this.$t("geneticsAndBreeding.yearlingWeightLb"),
          value: "yearlingWeight",
          class: "black--text text-no-wrap px-0",
          align: "start",
        },
        {
          text: this.$t(""),
          value: "actions",
          sortable: false,
          align: "start",
          class: "black--text text-no-wrap ",
          width: "10%",
        },
      ],
    };
  },
  methods: {
    closeAlert() {
      this.alertdialog = false;
      this.deleteItem = null;
    },
    // closeModal(){

    // },
    confirmDelete() {
      let epdIdList = [];
      if (this.deleteItem && this.deleteItem.id) {
        epdIdList.push(this.deleteItem.id);
      } else if (this.selected && this.selected.length > 0) {
        this.selected.forEach(epd => {
          epdIdList.push(epd.id);
        });
      }
      this.formSubmited = true;
      this.$apollo
        .mutate({
          mutation: gql`
            mutation removeEpd($id: String!) {
              removeEpd(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: JSON.stringify(epdIdList),
          },
        })
        .then(response => {
          if (response.data.removeEpd) {
            this.$apollo.queries.epdData.refetch();
            this.alertdialog = false;
            this.deleteItem = null;
            console.log("delete....");
          }
        })
        .catch(e => {
          console.log(e);
          this.$notify({
            title: `Epd Delete Problem.`,
            text: e.message,
            type: "error",
            position: "top right",
          });
        });
    },
    deleteEpdPage(item) {
      if (item && item.id) this.selected = [];
      this.deleteItem = item;
      this.alertdialog = true;
    },
    getEPDData() {
      //      //https://github.com/vuejs/apollo/issues/36
      console.log(
        this.tabs[this.tab],
        "this.tabs[this.tab]this.tabs[this.tab]"
      );
      console.log(
        this.$store.getters.getUser.id,
        "this.$store.getters.getUser.id,this.$store.getters.getUser.id,"
      );
      const { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
      const filter = {
        tab: this.tabs[this.tab],
        page: page,
        limit: itemsPerPage,
        searchPhrase: this.search,
        userId: parseInt(this.$store.getters.getUser.userDetail.id),
        //userId:6
      };

      if (sortBy.length === 1 && sortDesc.length === 1) {
        filter.sortCol = sortBy[0];
        filter.sortOrder = sortDesc[0] ? "DESC" : "ASC";
      }

      this.filter = filter;
      this.$apollo.queries.epdData.refetch();
    },
    searchEPD() {
      this.tableOptions.page = 1;
      this.items = [];
      this.getEPDData();
    },

    resetSearchOnEmpty() {
      if (this.search !== "") return;
      this.tableOptions.page = 1;
      this.getEPDData();
    },
    updateEpdPage(item) {
      this.$router.push({
        name: "EditGeneticsV2",
        params: { geneticid: item.animal_id },
      });
      // if(item.source == "LG CLOUD"){
      //   this.$router.push({name: 'EditGeneticsV2', params: {geneticid: item.animal_id }})
      // }else if(item.source == "LG COMM"){
      //   this.$router.push({name: 'EditGeneticsV2LgCom', params: {geneticid: item.animal_id }})
      // }
      //
    },

    pageChange(t) {
      if (t) this.tableOptions.page = Number(this.tableOptions.page) + 1;
      else this.tableOptions.page = Number(this.tableOptions.page) - 1;

      this.$router.replace({ query: { page: this.tableOptions.page } });
    },
    paginationChanged() {
      this.$router.replace({ query: { page: this.tableOptions.page } });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-data-table-header th {
  white-space: nowrap;
}
::v-deep .v-data-table-header__icon {
  display: inline-block;
  opacity: 100 !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>
